/* screens/support/pickFiles.js — разбор выбора файлов в композере поддержки.
   Отдельным модулем (без React и UI-импортов), чтобы правила проверялись
   тестом напрямую: это тот самый шов, на котором вложение терялось. */

/** Снять выбранные файлы с input'а и сбросить его — СИНХРОННО, одним шагом.
 *
 * Читать `input.files` ЛЕНИВО (внутри функционального updater'а setState)
 * нельзя: React 18 вправе выполнить updater уже ПОСЛЕ обработчика, а к тому
 * моменту `input.value = ''` очистил FileList — и снимок получался пустым.
 * Наружу это выглядело как «скрепка не работает»: окно выбора открывалось,
 * файл выбирался, а чип не появлялся; оператор дописывал текст и отправлял
 * ответ БЕЗ вложения, на сервер уходил обычный JSON-201 (в логах прода — ни
 * одной multipart-отправки с устройства при исправных текстовых ответах).
 * Композер Ассистента, который на тех же iPhone вложения отправляет, делает
 * ровно так: сперва снимок, потом сброс. */
export function takeFiles(input) {
  const picked = Array.from((input && input.files) || []);
  if (input) input.value = '';
  return picked;
}

/** Годные файлы + счётчик непрочитанных.
 *
 * Годным считаем только файл с НЕнулевым размером. Нулевой — не придирка к
 * формату: так iOS Safari отдаёт фото, которое лежит в iCloud и не выкачано на
 * устройство (а ещё сорвавшуюся конвертацию HEIC). Раньше такой файл молча
 * уезжал пустым вложением, которое клиент не мог открыть. */
export function usableFiles(picked) {
  const usable = (picked || []).filter((f) => f && f.size > 0);
  return { usable, lost: (picked || []).length - usable.length };
}
